// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterItemParentContent_root__1IhGF","amount":"FilterItemParentContent_amount__2tVk2","checkbox":"FilterItemParentContent_checkbox__2KHI_"};